function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Banner, Center, EmptyState, Row, Spinner } from "@neru/ui";
export var State = function(_param) {
    var children = _param.children, _param_emptyStateIcon = _param.emptyStateIcon, emptyStateIcon = _param_emptyStateIcon === void 0 ? "file-search-line" : _param_emptyStateIcon, _param_emptyStateMessage = _param.emptyStateMessage, emptyStateMessage = _param_emptyStateMessage === void 0 ? "No records found" : _param_emptyStateMessage, errorMessage = _param.errorMessage, isData = _param.isData, loading = _param.loading, withLoadMore = _param.withLoadMore, rest = _object_without_properties(_param, [
        "children",
        "emptyStateIcon",
        "emptyStateMessage",
        "errorMessage",
        "isData",
        "loading",
        "withLoadMore"
    ]);
    if (loading && !withLoadMore) {
        return /*#__PURE__*/ _jsx(Spinner, {});
    }
    if (errorMessage) {
        return /*#__PURE__*/ _jsx(Center, {
            paddingY: "xl",
            children: /*#__PURE__*/ _jsx(Banner, {
                connotation: "alert",
                "data-testid": "alert-banner",
                message: errorMessage,
                open: true
            })
        });
    }
    if (!isData && !loading) {
        var _rest_datatestid;
        return /*#__PURE__*/ _jsx(Center, {
            children: /*#__PURE__*/ _jsx(EmptyState, {
                "data-testid": (_rest_datatestid = rest["data-testid"]) !== null && _rest_datatestid !== void 0 ? _rest_datatestid : "empty-state",
                heading: emptyStateMessage,
                icon: emptyStateIcon
            })
        });
    }
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            children,
            withLoadMore && loading && /*#__PURE__*/ _jsx(Row, {
                className: "py-20",
                children: /*#__PURE__*/ _jsx(Spinner, {})
            })
        ]
    });
};

//# sourceMappingURL=State.js.map